import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { IMessageableEntity } from '../../interfaces/IMessageableEntity';

@Component({
  selector: 'ngx-select-users',
  templateUrl: './select-users.component.html',
  styleUrls: ['./select-users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectUsersModalComponent {
  usersSelected: IMessageableEntity[] = [];

  constructor(
    public dialModalRef: MatDialogRef<SelectUsersModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { usersDisabled: IMessageableEntity[] }
  ) {}

  addUsers() {
    this.dialModalRef.close(this.usersSelected);
  }

  close() {
    this.dialModalRef.close();
  }
}
